<template>
  <div class="w-full max-w-sm items-center flex-col p-3 customGradient" data-test="side-bar">
    <p class="text-white" :class="localStyles[0]" :style="hasGlobCssVar">Powered by</p>
    <p class="font-pensure text-3xl text-white" :class="localStyles[1]" :style="hasGlobCssVar">pensure</p>
    <img class="logo mt-12" :src="logoUrl" :class="localStyles[2]" />
    <p v-if="text" :class="localStyles[3]" :style="hasGlobCssVar" v-html="text" class="mt-3" />
  </div>
</template>

<script lang="ts" setup>
import { computed, onMounted, ref, defineProps } from 'vue';
import { LogoOptions } from '../store/modules/ui';
const props =
  defineProps<{
    logoPosition: LogoOptions['position'];
    logoUrl: string;
    text?: string;
  }>();
const styles = [
  { top: 'order-1 mt-3', bottom: 'order-2 mt-auto' },
  { top: 'order-2', bottom: 'order-3 mb-5' },
  { top: 'order-3', bottom: 'order-1 mt-3' },
  { top: 'order-4', bottom: 'order-4' },
];
const hasGlobCssVar = ref<string | null>(null);
const localStyles = styles.map((el) => el[props.logoPosition]);
onMounted(() => {
  hasGlobCssVar.value = getComputedStyle(document.documentElement).getPropertyValue('--logo-powered-by-color');
  if (!hasGlobCssVar.value) {
    hasGlobCssVar.value = dynamicTxtColor.value;
  } else {
    hasGlobCssVar.value = `color: ${hasGlobCssVar.value};`;
  }
});
const dynamicTxtColor = computed(() => {
  const colorToGet = getComputedStyle(document.documentElement).getPropertyValue('--color-bar-1');
  const bgColor = colorToGet
    ? colorToGet
    : getComputedStyle(document.documentElement).getPropertyValue('--color-primary');
  const color = bgColor.match(/[\d]+/g);
  if (!color) return null;
  const r = parseInt(color[0], 10);
  const g = parseInt(color[1], 10);
  const b = parseInt(color[2], 10);
  if ((r * 299 + g * 587 + b * 114) / 1000 > 160) {
    return 'color: rgb(40, 40, 40)';
  }
  return 'color: rgb(250, 250, 250)';
});
</script>
<style lang="scss" scoped>
.logo {
  width: var(--side-logo-bar-width, 15rem);
  max-height: 9rem;
}
.customGradient {
  background: linear-gradient(
    -30deg,
    var(--color-bar-1) 0%,
    42%,
    var(--color-bar-1) 42%,
    var(--color-bar-2) 42%,
    var(--color-bar-2) 45%,
    var(--color-bar-1) 100%
  );
}
</style>
